import { FC } from 'react'
import { DigitEl, DigitsWrapper } from './styled'

const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

export const Digit: FC<{ value: string; animated: boolean }> = ({
  value,
  animated,
}) => {
  return (
    <DigitsWrapper>
      {digits.map(d => (
        <DigitEl
          key={d}
          style={{ transform: `translateY(calc(-${value} * 100%)` }}
          animated={animated}
        >
          {d}
        </DigitEl>
      ))}
    </DigitsWrapper>
  )
}
